import { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Plus,
  RefreshCcw,
  Search,
  Pencil,
  X,
  Loader2,
  Calendar,
  FilePlus2,
  Table,
  History,
  IndianRupee,
  BadgeInfo,
} from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import MyContext from "../../../MyContext";
import "./CreditStyle.css";
import Loader from "../../Whatsapp/Loader";
import loader from "../../../images/Anlook.svg";
import AddVendorPurchaseModal from "./AddVendorPurchaseModal";
/** Endpoints */
const API = {
  LIST: "/api/Inventory/v1.0/getVendors",
  ADD: "/api/Inventory/v1.0/addVendor",
  EDIT: "/api/Inventory/v1.0/editVendor",
  DEL: "/api/Inventory/v1.0/deleteVendor",
  PAY: "/api/Transactions/v1.0/processVendorPayment",
  PURCHASE_ADD: "/api/Inventory/v1.0/insertVendorPurchaseDetails",
  PURCHASE_LIST: "/api/Inventory/v1.0/getVendorPurchaseDetails",
  VENDOR_BALANCE: "/api/Transactions/getWalletDetails",
};

const BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";

/** Static options */
const VENDOR_TYPES = [
  "Retailers",
  "Service providers",
  "Manufacturer",
  "Wholesaler",
  "Wholesalers or distributors",
  "Independent craftspeople",
  "B2c vendors",
  "Independent Vendor",
  "B2b",
  "Service vendors",
  "Retail vendors",
];
const PRODUCT_CATEGORIES = [
  "Electronics",
  "Dairy",
  "Toys",
  "Grocery",
  "Fresh Produce",
  "Meat & Seafood",
  "Bakery",
  "Beverages",
  "Frozen",
  "Household",
  "Personal Care",
  "Stationery",
  "Apparel",
  "Hardware",
  "Automotive",
  "Pharmacy",
  "Beauty",
  "Baby",
  "Pet Care",
  "Other",
];

/** Helpers */
const val = (...candidates) => {
  for (const c of candidates) {
    if (c !== undefined && c !== null && c !== "") return c;
  }
  return undefined;
};
const toCurrency = (numLike) => {
  const n = Number(numLike);
  if (Number.isFinite(n)) return `₹ ${n.toFixed(2)}`;
  const m = String(numLike ?? "").match(/^\d+(\.\d+)?$/);
  if (m) return `₹ ${Number(numLike).toFixed(2)}`;
  return "₹ —";
};
const maskAcct = (s) => {
  const str = String(s || "");
  if (!str) return "—";
  if (str.length <= 6) return str;
  return `${str.slice(0, 2)}••••••${str.slice(-4)}`;
};
const fmtDate = (s) => (s ? String(s) : "—");
const yes = (v) => String(v ?? "").toUpperCase() === "Y";

export default function VendorManager({ userID }) {
  const { baseUrl } = useContext(MyContext);
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("vendors"); // vendors | purchases

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [q, setQ] = useState("");

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [editing, setEditing] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Payment (from Purchase table)
  const [payOpen, setPayOpen] = useState(false);
  const [paying, setPaying] = useState(false);
  const [payAmount, setPayAmount] = useState("");
  const [payMode, setPayMode] = useState("imps"); // 'imps' | 'cash'
  const [payContext, setPayContext] = useState({
    vendorId: null,
    purchaseId: null,
    vendorName: "",
  });
  // Global Add Purchase (top button using v2.0 API)
  const [globalPurchaseOpen, setGlobalPurchaseOpen] = useState(false);

  // Add Purchase (from vendor row)
  const [purchaseOpen, setPurchaseOpen] = useState(false);
  const [purchaseVendor, setPurchaseVendor] = useState(null);
  const [addingPurchase, setAddingPurchase] = useState(false);
  const [purchaseForm, setPurchaseForm] = useState({
    amount: "",
    purchaseDescription: "",
    purchaseDate: new Date().toISOString().slice(0, 10),
  });

  // Purchase History
  const today = new Date().toISOString().slice(0, 10);
  const [purchaseRows, setPurchaseRows] = useState([]);
  const [purchaseLoading, setPurchaseLoading] = useState(false);
  const [fromDate, setFromDate] = useState(today); // default = today
  const [toDate, setToDate] = useState(today); // default = today

  // Drawer form
  const [form, setForm] = useState({
    vendorName: "",
    vendorType: "",
    vendorCategory: "",
    vendorAddress: "",
    gst: "",
    mobile: "",
    state: "",
    city: "",
    accountNumber: "",
    ifscCode: "",
    vendorId: null,
  });
  const [vendorBalance, setvendorBalance] = useState("");
  const [LoadingList, setLoadingList] = useState(false);

  const call = (path, payload) =>
    axios.post(`${baseUrl}${path}`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${BASIC_AUTH}`,
      },
    });

  /** Load vendors */
  async function fetchVendors() {
    if (!userID) return toast.error("Missing userid");
    try {
      setLoading(true);
      const res = await call(API.LIST, { userid: userID });
      if (res?.data?.responseCode === "00") {
        setRows(Array.isArray(res.data.response) ? res.data.response : []);
      } else {
        setRows([]);
        // toast.error(res?.data?.responseMessage || "Failed to fetch vendors");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching vendors");
    } finally {
      setLoading(false);
    }
  }

  async function fetchVendorsBalance() {
    if (!userID) return toast.error("Missing userid");
    setvendorBalance("Loading");
    try {
      setLoading(true);
      const res = await call(API.VENDOR_BALANCE, { userid: userID });
      if (res?.data?.responseCode === "00") {
        setvendorBalance(res.data.response.vendorPaymentBalance);
      } else {
        setvendorBalance("");
        toast.error(res?.data?.responseMessage || "Failed to fetch vendors");
        setvendorBalance("N/A");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching vendors");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchVendorsBalance();
  }, []); // eslint-disable-line

  /** Add/Edit/Delete vendor */
  async function addVendor(payload) {
    try {
      setSubmitting(true);
      const res = await call(API.ADD, {
        userid: userID,
        vendorName: payload.vendorName,
        vendorType: payload.vendorType,
        vendorAddress: payload.vendorAddress,
        vendorCategory: payload.vendorCategory,
        gst: payload.gst,
        mobile: payload.mobile,
        state: payload.state,
        city: payload.city,
        accountNumber: payload.accountNumber,
        ifscCode: payload.ifscCode,
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor added");
        setOpen(false);
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Add failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while adding vendor");
    } finally {
      setSubmitting(false);
    }
  }

  async function editVendor(payload) {
    try {
      setSubmitting(true);
      const res = await call(API.EDIT, {
        userid: userID,
        vendorId: payload.vendorId,
        vendorName: payload.vendorName,
        vendorType: payload.vendorType,
        vendorAddress: payload.vendorAddress,
        vendorCategory: payload.vendorCategory,
        gst: payload.gst,
        mobile: payload.mobile,
        state: payload.state,
        city: payload.city,
        accountNumber: payload.accountNumber,
        ifscCode: payload.ifscCode,
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor updated");
        setOpen(false);
        setEditing(null);
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Update failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while updating vendor");
    } finally {
      setSubmitting(false);
    }
  }

  async function deleteVendor(vendorId) {
    if (!window.confirm("Delete this vendor? This cannot be undone.")) return;
    try {
      setSubmitting(true);
      const res = await call(API.DEL, { userid: userID, vendorId });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Vendor deleted");
        fetchVendors();
      } else {
        toast.error(res?.data?.responseMessage || "Delete failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while deleting vendor");
    } finally {
      setSubmitting(false);
    }
  }

  /** Pay (from purchase row) */
  function openPayFromPurchase(pRow, mode = "imps") {
    const vendorId = String(val(pRow.fk_vendor_id, pRow.vendorId, ""));
    const purchaseId = String(val(pRow.id, pRow.purchaseId, ""));
    if (!vendorId || !purchaseId) return toast.error("Missing vendorId or purchaseId on this row");

    setPayContext({
      vendorId,
      purchaseId,
      vendorName: val(pRow.vendor_name, pRow.vendorName, `Vendor ${vendorId}`),
    });
    // Lock amount to the purchase amount; no editing in modal
    setPayAmount(String(val(pRow.amount, "")).replace(/[^\d.]/g, ""));
    setPayMode(mode); // 'imps' or 'cash'
    setPayOpen(true);
  }
  function closePay() {
    if (!paying) setPayOpen(false);
  }
  function validateAmount(v) {
    if (!v) return "Amount is required";
    if (!/^\d+(\.\d{1,2})?$/.test(v)) return "Enter a valid amount (max 2 decimals)";
    if (Number(v) <= 0) return "Amount must be greater than 0";
    return null;
  }
  async function processVendorPaymentUnified() {
    const err = validateAmount(payAmount);
    if (err) return toast.warning(err);
    if (!payContext.vendorId || !payContext.purchaseId) return toast.error("Missing vendor/purchase");

    try {
      setPaying(true);
      const res = await call(API.PAY, {
        userid: userID,
        amount: String(payAmount),
        vendorId: String(payContext.vendorId),
        purchaseId: String(payContext.purchaseId),
        mode: payMode, // 'imps' or 'cash'
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Payment processed");
        setPayOpen(false);
        if (fromDate && toDate) fetchVendorPurchaseDetails();
      } else {
        toast.error(res?.data?.responseMessage || "Payment failed");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while processing payment");
    } finally {
      setPaying(false);
    }
  }

  /** Add Purchase */
  function openAddPurchase(row) {
    setPurchaseVendor(row);
    setPurchaseForm({
      amount: "",
      purchaseDescription: "",
      purchaseDate: new Date().toISOString().slice(0, 10),
    });
    setPurchaseOpen(true);
  }
  function closeAddPurchase() {
    if (!addingPurchase) setPurchaseOpen(false);
  }
  function validatePurchaseForm({ amount, purchaseDate }) {
    const aerr = validateAmount(amount);
    if (aerr) return aerr;
    if (!purchaseDate) return "Purchase date is required";
    return null;
  }
  async function submitAddPurchase() {
    if (!purchaseVendor) return toast.error("Missing vendor");
    const err = validatePurchaseForm(purchaseForm);
    if (err) return toast.warning(err);

    try {
      setAddingPurchase(true);
      const vendorId = val(purchaseVendor.id, purchaseVendor.vendorId);
      const res = await call(API.PURCHASE_ADD, {
        userid: userID,
        vendorId: String(vendorId),
        amount: String(purchaseForm.amount),
        purchaseDescription: String(purchaseForm.purchaseDescription || ""),
        purchaseDate: String(purchaseForm.purchaseDate),
      });
      if (res?.data?.responseCode === "00") {
        toast.success(res?.data?.responseMessage || "Purchase added");
        setPurchaseOpen(false);
        setPurchaseVendor(null);
      } else {
        toast.error(res?.data?.responseMessage || "Failed to add purchase");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while adding purchase");
    } finally {
      setAddingPurchase(false);
    }
  }

  /** Purchase History */
  async function fetchVendorPurchaseDetails() {
    if (!userID) return toast.error("Missing userid");
    if (!fromDate || !toDate) return toast.warning("Please select From and To dates.");
    try {
      setPurchaseLoading(true);
      const res = await call(API.PURCHASE_LIST, {
        userid: userID,
        fromDate: String(fromDate),
        toDate: String(toDate),
      });
      if (res?.data?.responseCode === "00") {
        setPurchaseRows(Array.isArray(res.data.response) ? res.data.response : []);
      } else {
        setPurchaseRows([]);
        // toast.error(res?.data?.responseMessage || "Failed to fetch purchase history");
      }
    } catch (e) {
      console.error(e);
      toast.error("API error while fetching purchase history");
    } finally {
      setPurchaseLoading(false);
    }
  }

  /** Effects */
  useEffect(() => {
    fetchVendors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, baseUrl]);
  useEffect(() => {
    fetchVendorPurchaseDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID, fromDate, toDate]);
  /** Search filter */
  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return rows;
    return rows.filter((r) =>
      [
        r.vendorName,
        r.vendorType,
        r.vendorCategory,
        r.vendorAddress,
        r.gst,
        r.mobile,
        r.state,
        r.city,
        r.accountNumber ?? r.account_number,
        r.ifscCode ?? r.ifsc,
        r.vendorId ?? r.id,
        r.activation_status,
      ]
        .map((v) => String(v || "").toLowerCase())
        .some((s) => s.includes(needle))
    );
  }, [rows, q]);

  /** Utilities */
  function ensureOptionPresence(list, value) {
    if (!value) return list;
    return list.includes(value) ? list : [value, ...list];
  }
  const vendorTypeOptions = ensureOptionPresence(VENDOR_TYPES, form.vendorType);
  const productCategoryOptions = ensureOptionPresence(PRODUCT_CATEGORIES, form.vendorCategory);

  /** Drawer open/close */
  function openAdd() {
    setMode("add");
    setEditing(null);
    setForm({
      vendorName: "",
      vendorType: "",
      vendorCategory: "",
      vendorAddress: "",
      gst: "",
      mobile: "",
      state: "",
      city: "",
      accountNumber: "",
      ifscCode: "",
      vendorId: null,
    });
    setOpen(true);
  }
  function openEdit(row) {
    setMode("edit");
    setEditing(row);
    setForm({
      vendorName: val(row.vendorName, ""),
      vendorType: val(row.vendorType, ""),
      vendorCategory: val(row.vendorCategory, ""),
      vendorAddress: val(row.vendorAddress, ""),
      gst: val(row.gst, ""),
      mobile: val(row.mobile, ""),
      state: val(row.state, ""),
      city: val(row.city, ""),
      accountNumber: val(row.accountNumber, row.account_number, ""),
      ifscCode: val(row.ifscCode, row.ifsc, ""),
      vendorId: val(row.id, row.vendorId, null),
    });
    setOpen(true);
  }
  function closeDrawer() {
    if (!submitting) {
      setOpen(false);
      setEditing(null);
      toast.info("Action cancelled", { autoClose: 900 });
    }
  }

  /** Form validate */
  function validate() {
    if (!form.vendorName.trim()) return "Vendor name is required";
    if (form.mobile && !/^[6-9]\d{9}$/.test(form.mobile)) return "Enter valid 10-digit mobile";
    if (form.accountNumber && !/^\d{6,18}$/.test(form.accountNumber))
      return "Account number should be 6–18 digits";
    if (form.ifscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode.toUpperCase()))
      toast.info("IFSC format usually looks like ABCD0XXXXXX");
    return null;
  }
  async function onSubmit(e) {
    e?.preventDefault?.();
    const err = validate();
    if (err) return toast.warning(err);
    if (mode === "add") {
      await addVendor({ ...form });
    } else {
      if (!form.vendorId) return toast.error("vendorId missing for edit");
      await editVendor({ ...form });
    }
  }

  /** Navigation */
  function onCreatePurchase(row) {
    navigate("/Inventory/Vendors/CreatePurchase", { state: { vendor: row } });
  }

  return (
    <div className="admin-credit-wrap p-4">
      <ToastContainer position="top-right" theme="colored" closeOnClick pauseOnHover={false} />

      <div className="admin-credit-header">
        <div>
          <h3 className="admin-credit-title">Vendor Management</h3>
          <p className="admin-credit-subtitle">Create, edit, track purchases & settle payments</p>
        </div>
        <div className="admin-credit-actions">
          <button
            className="btn--md border rounded-2"
            disabled
            style={{ border: "1px solid #ccc", color: "black" }}
          >
            Vendor Balance: <b>₹ {vendorBalance}</b>
          </button>

          {/* New top-level Add Purchase button (v2.0 API) */}
          <button
            className="admin-btn admin-btn-primary btn--md"
            onClick={() => setGlobalPurchaseOpen(true)}
            disabled={loading}
          >
            <FilePlus2 size={18} /> Add Purchase
          </button>

          <button
            className="admin-btn admin-btn-primary btn--md"
            onClick={openAdd}
            disabled={submitting || loading}
          >
            <Plus size={18} /> Add Vendor
          </button>

          <button
            className="admin-btn admin-btn-neutral btn--md"
            onClick={fetchVendors}
            disabled={loading}
          >
            <RefreshCcw size={18} /> Refresh
          </button>
        </div>


      </div>

      <div className="admin-tabs">
        <button
          className={`admin-tab ${activeTab === "vendors" ? "active" : ""}`}
          onClick={() => setActiveTab("vendors")}
        >
          <Table size={16} />
          Vendors
        </button>
        <button
          className={`admin-tab ${activeTab === "purchases" ? "active" : ""}`}
          onClick={() => setActiveTab("purchases")}
        >
          <History size={16} />
          Purchase History
        </button>
      </div>

      <div className="admin-credit-toolbar">
        <div className="admin-input with-icon">
          <Search size={16} className="admin-input-icon" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search by name, GST, mobile, IFSC, city, status..."
          />
        </div>
        <div className="admin-meta">
          <span className="admin-badge">Total: {rows.length}</span>
          {loading ? <span className="admin-badge muted">Loading…</span> : null}
        </div>
      </div>

      {/* VENDORS TABLE */}
      {activeTab === "vendors" && (
        <div className="admin-table-wrap">
          {loading ? (
            <div className=" m-5 p-5 d-flex justify-content-center">
              <div className=" d-flex flex-column align-items-center justify-content-center ">
                <div className="p-3">
                  <div className="loader"> </div>
                </div>
                <div className="p-3">
                  <img src={loader} alt="" height={40} />
                </div>
              </div>
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th>Type / Category</th>
                  <th>Mobile</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Account #</th>
                  <th>Status</th>
                  <th>Created On</th>
                  {/* <th>Create Purchase</th> */}
                  <th>Add Purchase</th>
                  <th style={{ width: 120 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={14} className="center">
                      Loading…
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan={14} className="center muted">
                      No vendors found
                    </td>
                  </tr>
                ) : (
                  filtered.map((r) => {
                    const name = val(r.vendorName, "—");
                    const vType = val(r.vendorType, "—");
                    const vCat = val(r.vendorCategory, "—");
                    const gst = val(r.gst, "—");
                    const mobile = val(r.mobile, "—");
                    const state = val(r.state, "—");
                    const city = val(r.city, "—");
                    const acct = val(r.accountNumber, r.account_number, "—");
                    const created = val(r.createdOn, r.created_on, "—");
                    const status = String(val(r.activation_status, "active")).toLowerCase();
                    const statusBadge = status === "active" ? "success" : status === "inactive" ? "warning" : "muted";

                    return (
                      <tr key={val(r.id, r.vendorId, Math.random())}>
                        <td>
                          <div className="flex-col">
                            <div className="semi">{name}</div>
                            <div className="muted mono" title={gst}>
                              <BadgeInfo size={12} style={{ marginRight: 4 }} />
                              GST: {gst}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                            <span className="admin-badge">{vType}</span>
                            <span className="admin-badge muted">{vCat}</span>
                          </div>
                        </td>
                        <td className="mono">{mobile}</td>
                        <td>{state}</td>
                        <td>{city}</td>
                        <td className="mono trunc" title={acct}>
                          {maskAcct(acct)}
                        </td>
                        <td>
                          <span className={`admin-badge ${statusBadge}`}>
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </span>
                        </td>
                        <td>{fmtDate(created)}</td>
                        {/* <td>
                          <button className="admin-btn admin-btn-neutral btn--md" onClick={() => onCreatePurchase(r)}>
                            + Purchase
                          </button>
                        </td> */}
                        <td>
                          <button className="admin-btn admin-btn-primary btn--md" onClick={() => openAddPurchase(r)}>
                            <FilePlus2 size={16} style={{ marginRight: 6 }} />
                            Add
                          </button>
                        </td>
                        <td className="row-actions">
                          <button className="admin-icon-btn" title="Edit" onClick={() => openEdit(r)}>
                            <Pencil size={16} />
                          </button>
                          {/* Delete intentionally disabled */}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* PURCHASE HISTORY */}
      {activeTab === "purchases" && (
        <div className="admin-card">
          <div className="admin-credit-toolbar">
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Calendar size={16} />
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="admin-input-control"
                style={{ minWidth: 170 }}
              />
              <span style={{ opacity: 0.6 }}>to</span>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="admin-input-control"
                style={{ minWidth: 170 }}
              />
              <button
                className="admin-btn admin-btn-primary btn--md"
                onClick={fetchVendorPurchaseDetails}
                disabled={purchaseLoading}
              >
                {purchaseLoading ? <Loader2 className="admin-spin" size={16} /> : <RefreshCcw size={16} />}
                <span style={{ marginLeft: 6 }}>Search</span>
              </button>
            </div>
          </div>

          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Purchase ID</th>
                  <th>Vendor ID</th>
                  <th>Vendor</th>
                  <th>Description</th>
                  <th className="right">Amount</th>
                  <th>Purchase Date</th>
                  <th>Paid</th>
                  <th>Created On</th>
                  <th>Account #</th>
                  <th>Mode</th>
                  <th style={{ width: 180 }}>Pay</th>
                </tr>
              </thead>
              <tbody>
                {purchaseLoading ? (
                  <tr>
                    <td colSpan={11} className="center">
                      Loading…
                    </td>
                  </tr>
                ) : purchaseRows.length === 0 ? (
                  <tr>
                    <td colSpan={11} className="center muted">
                      No purchase records
                    </td>
                  </tr>
                ) : (
                  purchaseRows.map((p, idx) => {
                    const purchaseId = val(p.id, p.purchaseId, "—");
                    const vendorId = val(p.fk_vendor_id, p.vendorId, "—");
                    const vendorName = val(p.vendor_name, p.vendorName, null);
                    const desc = val(p.purchase_description, p.purchaseDescription, p.description, "—");
                    const amt = val(p.amount, "—");
                    const pDate = val(p.purchase_date, p.purchaseDate, "—");
                    const createdOn = val(p.created_on, p.createdOn, "—");
                    const paid = yes(p.paid);
                    const acct = val(p.account_number, "");
                    const ifsc = val(p.ifsc_code, p.ifsc, "");
                    const Mode = val(p.mode, p.mode, "");

                    return (
                      <tr key={purchaseId || idx}>
                        <td className="mono">{purchaseId}</td>
                        <td className="mono">{vendorId}</td>
                        <td>{vendorName || <span className="admin-badge muted">Unknown</span>}</td>
                        <td className="trunc" title={desc}>
                          {desc}
                        </td>
                        <td className="right mono">{toCurrency(amt)}</td>
                        <td>{fmtDate(pDate)}</td>
                        <td>
                          <span className={`admin-badge ${paid ? "success" : "warning"}`}>
                            {paid ? "Paid" : "Unpaid"}
                          </span>
                        </td>
                        <td>{fmtDate(createdOn)}</td>
                        <td className="mono trunc" title={acct || "—"}>
                          {acct ? maskAcct(acct) : "—"}
                        </td>
                        <td className="mono">{Mode || "—"}</td>
                        <td style={{ display: "flex", gap: 8 }}>
                          <button
                            className="admin-btn admin-btn-primary btn--md"
                            onClick={() => openPayFromPurchase(p, "imps")}
                            disabled={paid}
                            title={paid ? "Already paid" : "Pay via IMPS"}
                          >
                            <IndianRupee size={16} style={{ marginRight: 6 }} />
                            Pay (IMPS)
                          </button>
                          <button
                            className="admin-btn admin-btn-neutral btn--md"
                            onClick={() => openPayFromPurchase(p, "cash")}
                            disabled={paid}
                            title={paid ? "Already paid" : "Pay with Cash"}
                          >
                            <IndianRupee size={16} style={{ marginRight: 6 }} />
                            Pay Cash
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ADD / EDIT VENDOR */}
      {open && (
        <div className="admin-drawer-backdrop" onClick={closeDrawer}>
          <div className="admin-drawer admin-drawer-compact" onClick={(e) => e.stopPropagation()}>
            <div className="admin-drawer-header">
              <h4 className="admin-drawer-title">{mode === "add" ? "Add Vendor" : "Edit Vendor"}</h4>
              <button className="admin-icon-btn" onClick={closeDrawer}>
                <X size={18} />
              </button>
            </div>

            <form className="admin-drawer-body admin-drawer-form admin-drawer-scroll" onSubmit={onSubmit}>
              <div className="admin-field">
                <label>
                  Vendor Name <span className="req">*</span>
                </label>
                <input
                  className="admin-input-control"
                  value={form.vendorName}
                  onChange={(e) => setForm((f) => ({ ...f, vendorName: e.target.value }))}
                  required
                />
              </div>

              <div className="admin-field">
                <label>Vendor Type</label>
                <select
                  className="admin-input-control"
                  value={form.vendorType}
                  onChange={(e) => setForm((f) => ({ ...f, vendorType: e.target.value }))}
                >
                  <option value="">Select Vendor Type</option>
                  {vendorTypeOptions.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-field">
                <label>Product Category</label>
                <select
                  className="admin-input-control"
                  value={form.vendorCategory}
                  onChange={(e) => setForm((f) => ({ ...f, vendorCategory: e.target.value }))}
                >
                  <option value="">Select Product Category</option>
                  {productCategoryOptions.map((c) => (
                    <option key={c} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>

              <div className="admin-field">
                <label>Address</label>
                <textarea
                  className="admin-input-control"
                  rows={3}
                  value={form.vendorAddress}
                  onChange={(e) => setForm((f) => ({ ...f, vendorAddress: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>GST</label>
                <input
                  className="admin-input-control mono"
                  value={form.gst}
                  onChange={(e) => setForm((f) => ({ ...f, gst: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>Mobile</label>
                <input
                  className="admin-input-control mono"
                  inputMode="numeric"
                  maxLength={10}
                  value={form.mobile}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, mobile: e.target.value.replace(/\D/g, "").slice(0, 10) }))
                  }
                />
              </div>

              <div className="admin-field">
                <label>State</label>
                <input
                  className="admin-input-control"
                  value={form.state}
                  onChange={(e) => setForm((f) => ({ ...f, state: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>City</label>
                <input
                  className="admin-input-control"
                  value={form.city}
                  onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>Account Number</label>
                <input
                  className="admin-input-control mono"
                  inputMode="numeric"
                  maxLength={18}
                  value={form.accountNumber}
                  onChange={(e) =>
                    setForm((f) => ({
                      ...f,
                      accountNumber: e.target.value.replace(/\D/g, "").slice(0, 18),
                    }))
                  }
                  placeholder="e.g., 012345678901"
                />
              </div>

              <div className="admin-field">
                <label>IFSC Code</label>
                <input
                  className="admin-input-control mono"
                  value={form.ifscCode}
                  onChange={(e) =>
                    setForm((f) => ({ ...f, ifscCode: e.target.value.toUpperCase().slice(0, 11) }))
                  }
                  placeholder="e.g., HDFC0001234"
                />
              </div>

              <div className="admin-drawer-footer sticky-footer">
                <button type="button" className="admin-btn admin-btn-neutral btn--md" onClick={closeDrawer}>
                  Cancel
                </button>
                <button type="submit" className="admin-btn admin-btn-primary btn--md" disabled={submitting}>
                  {submitting ? <Loader2 className="admin-spin" size={16} /> : null}
                  {mode === "add" ? "Save" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* PAY MODAL */}
      {payOpen && (
        <div className="admin-modal-backdrop" onClick={closePay}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h4 className="admin-drawer-title">Pay / Settle Purchase</h4>
              <button className="admin-icon-btn" onClick={closePay}>
                <X size={18} />
              </button>
            </div>

            <div className="admin-drawer-body admin-drawer-form">
              <div className="admin-field">
                <label>Vendor</label>
                <div className="admin-input-control" style={{ opacity: 0.9 }}>
                  {payContext.vendorName || "—"} (Vendor ID: {payContext.vendorId || "—"})
                </div>
              </div>
              <div className="admin-field">
                <label>Purchase ID</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9 }}>
                  {payContext.purchaseId || "—"}
                </div>
              </div>
              {/* Amount shown as read-only per requirement */}
              <div className="admin-field">
                <label>Amount</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9 }}>
                  {toCurrency(payAmount)}
                </div>
              </div>
              <div className="admin-field">
                <label>Mode</label>
                <div className="admin-input-control mono" style={{ opacity: 0.9, textTransform: "uppercase" }}>
                  {payMode}
                </div>
              </div>
            </div>

            <div className="admin-modal-actions">
              <button className="admin-btn admin-btn-neutral btn--md" onClick={closePay} disabled={paying}>
                Cancel
              </button>
              <button className="admin-btn admin-btn-primary btn--md" onClick={processVendorPaymentUnified} disabled={paying}>
                {paying ? <Loader2 className="admin-spin" size={16} /> : <IndianRupee size={16} />}
                <span style={{ marginLeft: 6 }}>
                  {paying ? "Processing…" : payMode === "cash" ? "Confirm Cash" : "Pay (IMPS)"}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ADD PURCHASE MODAL */}
      {purchaseOpen && (
        <div className="admin-modal-backdrop" onClick={closeAddPurchase}>
          <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h4 className="admin-drawer-title">Add Purchase</h4>
              <button className="admin-icon-btn" onClick={closeAddPurchase}>
                <X size={18} />
              </button>
            </div>

            <div className="admin-drawer-body admin-drawer-form admin-drawer-scroll">
              <div className="admin-field">
                <label>Vendor</label>
                <div className="admin-input-control" style={{ opacity: 0.9 }}>
                  {purchaseVendor?.vendorName || "—"} (ID: {val(purchaseVendor?.id, purchaseVendor?.vendorId, "—")})
                </div>
              </div>

              <div className="admin-field">
                <label>
                  Amount <span className="req">*</span>
                </label>
                <input
                  className="admin-input-control mono"
                  inputMode="decimal"
                  placeholder="e.g., 1500 or 1500.50"
                  value={purchaseForm.amount}
                  onChange={(e) =>
                    setPurchaseForm((f) => ({
                      ...f,
                      amount: e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1")
                        .slice(0, 12),
                    }))
                  }
                />
              </div>

              <div className="admin-field">
                <label>Description</label>
                <textarea
                  className="admin-input-control"
                  rows={3}
                  placeholder="Optional description"
                  value={purchaseForm.purchaseDescription}
                  onChange={(e) => setPurchaseForm((f) => ({ ...f, purchaseDescription: e.target.value }))}
                />
              </div>

              <div className="admin-field">
                <label>
                  Purchase Date <span className="req">*</span>
                </label>
                <input
                  type="date"
                  className="admin-input-control"
                  value={purchaseForm.purchaseDate}
                  onChange={(e) => setPurchaseForm((f) => ({ ...f, purchaseDate: e.target.value }))}
                />
              </div>
            </div>

            <div className="admin-modal-actions">
              <button className="admin-btn admin-btn-neutral btn--md" onClick={closeAddPurchase} disabled={addingPurchase}>
                Cancel
              </button>
              <button className="admin-btn admin-btn-primary btn--md" onClick={submitAddPurchase} disabled={addingPurchase}>
                {addingPurchase ? <Loader2 className="admin-spin" size={16} /> : null}
                Add Purchase
              </button>
            </div>
          </div>
        </div>
      )}
      <AddVendorPurchaseModal
        isOpen={globalPurchaseOpen}
        onClose={() => setGlobalPurchaseOpen(false)}
        userID={userID}
        onSuccess={fetchVendorPurchaseDetails}
      />
    </div>
  );
}
